import {
  PennDotDistricts,
  CrashSeverity,
  SafetyIntxType,
  AtGradeExpectedIntxTypes,
  UrbanSubIntxTypes,
  AtGradeExpectedIntxTypesUrbanSub,
  AreaType,
} from "./SPFConstants";
import { getThreeLegMinorStopSpfForDistrict } from "./UrbanSubArt-ThreeLeg";
import {
  RoundaboutSpfs,
  get3LegRoundaboutSPFs,
  get4LegRoundaboutSPFs,
  getExpectedCrashes,
  getFatalInjuryCrashRatio,
  getUrbanThreeLegSignalSpfs,
} from "./spfHelpers";
const CalibrationFactorforFourLegMinor = {
  [PennDotDistricts.DISTRICT_1]: { total: 1.0, fatalInjury: 1.0 },
  [PennDotDistricts.DISTRICT_2]: { total: 1.0, fatalInjury: 1.0 },
  [PennDotDistricts.DISTRICT_3]: { total: 1.0, fatalInjury: 1.0 },
  [PennDotDistricts.DISTRICT_4]: { total: 1.0, fatalInjury: 1.0 },
  [PennDotDistricts.DISTRICT_5]: { total: 1.44, fatalInjury: 1.44 },
  [PennDotDistricts.DISTRICT_6]: { total: 1.16, fatalInjury: 1.14 },
  [PennDotDistricts.DISTRICT_8]: { total: 1.44, fatalInjury: 1.44 },
  [PennDotDistricts.DISTRICT_9]: { total: 1.0, fatalInjury: 1.0 },
  [PennDotDistricts.DISTRICT_10]: { total: 1.0, fatalInjury: 1.0 },
  [PennDotDistricts.DISTRICT_11]: { total: 1.0, fatalInjury: 1.0 },
  [PennDotDistricts.DISTRICT_12]: { total: 1.0, fatalInjury: 1.0 },
};
const CalibrationFactorforFourLegSignal = {
  [PennDotDistricts.DISTRICT_1]: { total: 0.78, fatalInjury: 0.74 },
  [PennDotDistricts.DISTRICT_2]: { total: 0.78, fatalInjury: 0.74 },
  [PennDotDistricts.DISTRICT_3]: { total: 0.71, fatalInjury: 0.64 },
  [PennDotDistricts.DISTRICT_4]: { total: 1.11, fatalInjury: 1.09 },
  [PennDotDistricts.DISTRICT_5]: { total: 1.0, fatalInjury: 1.0 },
  [PennDotDistricts.DISTRICT_6]: { total: 1.0, fatalInjury: 1.0 },
  [PennDotDistricts.DISTRICT_8]: { total: 0.88, fatalInjury: 0.79 },
  [PennDotDistricts.DISTRICT_9]: { total: 0.88, fatalInjury: 0.79 },
  [PennDotDistricts.DISTRICT_10]: { total: 0.71, fatalInjury: 0.64 },
  [PennDotDistricts.DISTRICT_11]: { total: 0.96, fatalInjury: 0.83 },
  [PennDotDistricts.DISTRICT_12]: { total: 0.78, fatalInjury: 0.74 },
};
const CrashModificationFactorforFourLegAllStop = {
  total: 0.96,
  fatalInjury: 0.85,
};

const getSPFsForIntxType = (intxType: SafetyIntxType) => {
  switch (intxType) {
    case SafetyIntxType.FOUR_LEG_MINOR_STOP:
      return {
        getTotalPredicted: ({
          majorRoad,
          minorRoad,
          pennDotDistrict,
        }: UrbanSubIntxTypes): number =>
          Math.exp(-6.909) *
          Math.pow(majorRoad.aadt, 0.53) *
          Math.pow(minorRoad.aadt, 0.279) *
          Math.exp(
            0.183 *
              Number(majorRoad.speedLimit >= 40 && majorRoad.speedLimit <= 45)
          ) *
          Math.exp(
            0.356 *
              Number(majorRoad.speedLimit >= 50 && majorRoad.speedLimit <= 55)
          ) *
          Math.exp(0.131 * Number(minorRoad.speedLimit >= 40)) *
          CalibrationFactorforFourLegMinor[pennDotDistrict].total,
        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
          pennDotDistrict,
        }: UrbanSubIntxTypes): number =>
          Math.exp(-8.223) *
          Math.pow(majorRoad.aadt, 0.585) *
          Math.pow(minorRoad.aadt, 0.296) *
          Math.exp(
            0.132 *
              Number(majorRoad.speedLimit >= 40 && majorRoad.speedLimit <= 45)
          ) *
          Math.exp(
            0.396 *
              Number(majorRoad.speedLimit >= 50 && majorRoad.speedLimit <= 55)
          ) *
          Math.exp(0.169 * Number(minorRoad.speedLimit >= 40)) *
          CalibrationFactorforFourLegMinor[pennDotDistrict].fatalInjury,
      };
    case SafetyIntxType.THREE_LEG_ALL_STOP:
    case SafetyIntxType.FOUR_LEG_ALL_STOP:
      return {
        getTotalPredicted: ({
          majorRoad,
          minorRoad,
        }: UrbanSubIntxTypes): number =>
          Math.exp(-6.909) *
          Math.pow(majorRoad.aadt, 0.53) *
          Math.pow(minorRoad.aadt, 0.279) *
          Math.exp(
            0.183 *
              Number(majorRoad.speedLimit >= 40 && majorRoad.speedLimit <= 45)
          ) *
          Math.exp(
            0.356 *
              Number(majorRoad.speedLimit >= 50 && majorRoad.speedLimit <= 55)
          ) *
          Math.exp(0.131 * Number(minorRoad.speedLimit >= 40)) *
          CrashModificationFactorforFourLegAllStop.total,
        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
          pennDotDistrict,
        }: UrbanSubIntxTypes): number =>
          Math.exp(-8.223) *
          Math.pow(majorRoad.aadt, 0.585) *
          Math.pow(minorRoad.aadt, 0.296) *
          Math.exp(
            0.132 *
              Number(majorRoad.speedLimit >= 40 && majorRoad.speedLimit <= 45)
          ) *
          Math.exp(
            0.396 *
              Number(majorRoad.speedLimit >= 50 && majorRoad.speedLimit <= 55)
          ) *
          Math.exp(0.169 * Number(minorRoad.speedLimit >= 40)) *
          CrashModificationFactorforFourLegAllStop.fatalInjury,
      };
    case SafetyIntxType.THREE_LEG_SIGNAL:
      return getUrbanThreeLegSignalSpfs();
    case SafetyIntxType.FOUR_LEG_SIGNAL:
      return {
        getTotalPredicted: ({
          majorRoad,
          minorRoad,
          pennDotDistrict,
        }: UrbanSubIntxTypes): number =>
          Math.exp(-5.501) *
          Math.pow(majorRoad.aadt, 0.403) *
          Math.pow(minorRoad.aadt, 0.316) *
          Math.exp(0.053 * Number(majorRoad.hasExclusiveLeft)) *
          Math.exp(0.126 * Number(majorRoad.hasExclusiveRight)) *
          Math.exp(0.056 * Number(minorRoad.hasExclusiveLeft)) *
          Math.exp(0.045 * Number(minorRoad.hasExclusiveRight)) *
          Math.exp(
            0.101 *
              Number(majorRoad.speedLimit >= 40 && majorRoad.speedLimit <= 45)
          ) *
          Math.exp(
            0.29 *
              Number(majorRoad.speedLimit >= 50 && majorRoad.speedLimit <= 55)
          ) *
          Math.exp(0.075 * Number(minorRoad.speedLimit >= 35)) *
          CalibrationFactorforFourLegSignal[pennDotDistrict].total,

        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
          pennDotDistrict,
        }: UrbanSubIntxTypes): number =>
          Math.exp(-6.374) *
          Math.pow(majorRoad.aadt, 0.411) *
          Math.pow(minorRoad.aadt, 0.363) *
          Math.exp(0.13 * Number(majorRoad.hasExclusiveLeft)) *
          Math.exp(0.053 * Number(minorRoad.hasExclusiveLeft)) *
          Math.exp(
            0.226 *
              Number(majorRoad.speedLimit >= 50 && majorRoad.speedLimit <= 55)
          ) *
          CalibrationFactorforFourLegSignal[pennDotDistrict].fatalInjury,
      };
    case SafetyIntxType.THREE_LEG_MINOR_STOP:
      return {
        getTotalPredicted: (props: UrbanSubIntxTypes): number =>
          getThreeLegMinorStopSpfForDistrict(
            props.pennDotDistrict
          ).getTotalPredicted(props),

        getFatalInjuryPredicted: (props: UrbanSubIntxTypes): number =>
          getThreeLegMinorStopSpfForDistrict(
            props.pennDotDistrict
          ).getFatalInjuryPredicted(props),
      };
    case SafetyIntxType.THREE_LEG_ROUNDABOUT:
      return get3LegRoundaboutSPFs(AreaType.URBAN);
    case SafetyIntxType.FOUR_LEG_ROUNDABOUT:
      return get4LegRoundaboutSPFs(AreaType.URBAN);
    default:
      throw new Error(`Could not find SPFs for intersection type ${intxType}`);
  }
};

const getFatalInjuryPredictedInitial = (props: UrbanSubIntxTypes) => {
  return getSPFsForIntxType(props.intxType)?.getFatalInjuryPredicted(props);
};

const getPdoPredictedInitial = (props: UrbanSubIntxTypes) => {
  const { getPDOPredicted } = getSPFsForIntxType(
    props.intxType
  ) as RoundaboutSpfs;
  if (!getPDOPredicted) {
    throw new Error("Could not find getPDOPredicted function");
  }
  return getPDOPredicted(props);
};

export const getFatalInjuryPredicted = (props: UrbanSubIntxTypes): number => {
  if (
    props.intxType === SafetyIntxType.THREE_LEG_ROUNDABOUT ||
    props.intxType === SafetyIntxType.FOUR_LEG_ROUNDABOUT
  ) {
    const fiInitial = getFatalInjuryPredictedInitial(props);
    const totalPredicted = getTotalPredicted(props);
    const pdoInitial = getPdoPredictedInitial(props);

    return getFatalInjuryCrashRatio({
      fiInitial,
      pdoInitial,
      totalCrashes: totalPredicted,
    });
  }
  return getFatalInjuryPredictedInitial(props);
};

export const getTotalPredicted = (props: UrbanSubIntxTypes): number => {
  return getSPFsForIntxType(props.intxType)?.getTotalPredicted(props);
};

export const getTotalExpected = (props: AtGradeExpectedIntxTypes): number =>
  getExpectedCrashes({
    ...props,
    crashSeverity: CrashSeverity.TOTAL,
    getPredictedCrashes: getTotalPredicted,
  });

export const getFatalInjuryExpected = (
  props: AtGradeExpectedIntxTypesUrbanSub
): number => {
  if (
    props.intxType === SafetyIntxType.THREE_LEG_ROUNDABOUT ||
    props.intxType === SafetyIntxType.FOUR_LEG_ROUNDABOUT
  ) {
    const fiInitial = getFatalInjuryPredictedInitial(props);
    const totalExpected = getTotalExpected(props);
    const pdoInitial = getPdoPredictedInitial(props);

    return getFatalInjuryCrashRatio({
      fiInitial,
      pdoInitial,
      totalCrashes: totalExpected,
    });
  }
  return getExpectedCrashes({
    ...props,
    crashSeverity: CrashSeverity.FATAL_INJURY,
    getPredictedCrashes: getFatalInjuryPredicted,
  });
};
